import { baseRoutes } from './routes'

import { CampaignsIcon, User } from 'shared'
import { ProfileIcon, ResourcesIcon } from 'assets/icons'
import { SvgIconProps } from '@mui/material'

export const getLinks = (user: User | null) => {
  if (!user) return []

  const initialLinks: {
    name: string
    url: string
    Icon: (props: SvgIconProps) => JSX.Element
  }[] = [
    {
      name: 'Profile',
      url: baseRoutes.profile,
      Icon: ProfileIcon,
    },
    {
      name: 'Campaigns',
      url: baseRoutes.campaigns,
      Icon: CampaignsIcon,
    },
  ]

  if (!user.isFilterGroup) {
    initialLinks.push({
      name: 'Resources',
      Icon: ResourcesIcon,
      url: baseRoutes.resources,
    })
  }

  return initialLinks
}
